'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; /* eslint-disable */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _admin = require('redux/modules/admin');

var adminActions = _interopRequireWildcard(_admin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DatePicker = require('react-bootstrap-date-picker');

var validUsername = false;
var validFirstname = false;

var AdminUsers = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    user_ids: state.admin.user_ids
  };
}, adminActions), _dec(_class = function (_Component) {
  (0, _inherits3.default)(AdminUsers, _Component);

  function AdminUsers() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AdminUsers);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AdminUsers.__proto__ || (0, _getPrototypeOf2.default)(AdminUsers)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      username: '',
      firstname: '',
      gender: '',
      childname: '',
      childgender: '',
      childdob: '',
      surveylink: '',
      password: '',
      showUserHelp: false,
      showEmailHelp: false,
      showFirstnameHelp: false,
      showModal: false
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _this.handleDOBChange = function (value) {
      _this.setState({
        childdob: value
      });
    }, _this.generatedPassword = function () {
      var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
      var pass = "";
      for (var x = 0; x < 12; x++) {
        var i = Math.floor(Math.random() * chars.length);
        pass += chars.charAt(i);
      }
      return pass;
    }, _this.handleSubmit = function (event) {
      event.preventDefault();

      if (!validUsername) _this.setState({ showUserHelp: true });
      if (!validFirstname) _this.setState({ showFirstnameHelp: true });

      console.log('Handle submit!');
      console.log(_this.state);

      if (validUsername && validFirstname) {
        // call register function
        var values = {
          username: _this.state.username,
          password: _this.state.password,
          parentName: _this.state.firstname,
          childName: _this.state.childname,
          childDOB: _this.state.childdob,
          childGender: _this.state.childgender,
          surveyLink: _this.state.surveylink
        };
        console.log(values);
        // create user
        _this.props.createUser(values);
        // user created pop-up
        _this.setState({ showModal: true });
      }
    }, _this.close = function () {
      var obj = _this.state;
      obj.showModal = false;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AdminUsers, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.state.password = this.generatedPassword();
    }

    /* ************************************ */
    /* FUNCTIONS TO CHECK FOR VALID INPUT   */
    /* ************************************ */

  }, {
    key: 'getUsernameValidation',
    value: function getUsernameValidation() {
      var _this2 = this;

      var length = this.state.username.length;
      var userID = this.props.user_ids.find(function (o) {
        return o.username === _this2.state.username;
      });
      if (length > 4 && userID === undefined) {
        if (!this.state.isValidUsername) validUsername = true;
        return 'success';
      } else if (this.state.showUserHelp) {
        return 'error';
      } else {
        if (this.state.isValidUsername) validUsername = false;
        return null;
      }
    }
  }, {
    key: 'getFirstnameValidation',
    value: function getFirstnameValidation() {
      var length = this.state.firstname.length;
      if (length > 0) {
        if (!this.state.isValidFirstname) validFirstname = true;
        return 'success';
      } else if (this.state.showFirstnameHelp) {
        return 'error';
      } else {
        if (this.state.isValidFirstname) validFirstname = false;
      }
    }

    /* ****************************** */
    /* HANDLE FORM CHANGE FUNCTIONS   */
    /* ****************************** */

    // without handleChange, form value fields would not change on the front end


    // close modal

  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          username = _state.username,
          firstname = _state.firstname,
          childname = _state.childname,
          childGender = _state.childGender,
          surveylink = _state.surveylink,
          showUserHelp = _state.showUserHelp,
          showFirstnameHelp = _state.showFirstnameHelp,
          showEmailHelp = _state.showEmailHelp;

      var styles = require('./Admin.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Row,
          null,
          _react2.default.createElement(
            ReactBootstrap.Col,
            { md: 12 },
            _react2.default.createElement(
              'h1',
              null,
              'Create new user'
            ),
            _react2.default.createElement(
              'form',
              null,
              _react2.default.createElement(
                ReactBootstrap.FormGroup,
                { validationState: this.getUsernameValidation() },
                _react2.default.createElement(
                  ReactBootstrap.ControlLabel,
                  null,
                  '* Username: '
                ),
                _react2.default.createElement(ReactBootstrap.FormControl, {
                  type: 'text',
                  placeholder: 'Enter username',
                  value: username,
                  onChange: this.handleChange.bind(this, 'username') }),
                _react2.default.createElement(ReactBootstrap.FormControl.Feedback, null),
                showUserHelp && _react2.default.createElement(
                  ReactBootstrap.HelpBlock,
                  null,
                  'Username already exists or is less than 4 characters'
                )
              ),
              _react2.default.createElement(
                ReactBootstrap.FormGroup,
                { validationState: this.getFirstnameValidation() },
                _react2.default.createElement(
                  ReactBootstrap.ControlLabel,
                  null,
                  '* Parent first name:'
                ),
                _react2.default.createElement(ReactBootstrap.FormControl, {
                  type: 'text',
                  placeholder: 'First name',
                  value: firstname,
                  onChange: this.handleChange.bind(this, 'firstname') }),
                _react2.default.createElement(ReactBootstrap.FormControl.Feedback, null),
                showFirstnameHelp && _react2.default.createElement(
                  ReactBootstrap.HelpBlock,
                  null,
                  'Enter your first name.'
                )
              ),
              _react2.default.createElement(
                ReactBootstrap.FormGroup,
                null,
                _react2.default.createElement(
                  ReactBootstrap.ControlLabel,
                  null,
                  'Child first name:'
                ),
                _react2.default.createElement(ReactBootstrap.FormControl, {
                  type: 'text',
                  placeholder: 'Child first name',
                  value: childname,
                  onChange: this.handleChange.bind(this, 'childname') }),
                _react2.default.createElement(ReactBootstrap.FormControl.Feedback, null)
              ),
              _react2.default.createElement(
                ReactBootstrap.FormGroup,
                { onChange: this.handleChange.bind(this, 'childgender') },
                _react2.default.createElement(
                  ReactBootstrap.ControlLabel,
                  null,
                  'Child gender: \xA0'
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { inline: true, name: 'childgender', value: 'Male' },
                  'Male'
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { inline: true, name: 'childgender', value: 'Female' },
                  'Female'
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { inline: true, name: 'childgender', value: 'Other' },
                  'Other'
                ),
                _react2.default.createElement(ReactBootstrap.FormControl.Feedback, null)
              ),
              _react2.default.createElement(
                ReactBootstrap.FormGroup,
                null,
                _react2.default.createElement(
                  ReactBootstrap.ControlLabel,
                  null,
                  'Child date of birth: \xA0'
                ),
                _react2.default.createElement(DatePicker, { id: 'childdob', value: this.state.childdob, onChange: this.handleDOBChange, dateFormat: 'DD/MM/YYYY' }),
                _react2.default.createElement(ReactBootstrap.FormControl.Feedback, null)
              ),
              _react2.default.createElement(
                ReactBootstrap.FormGroup,
                null,
                _react2.default.createElement(
                  ReactBootstrap.ControlLabel,
                  null,
                  'Link to survey:'
                ),
                _react2.default.createElement(ReactBootstrap.FormControl, {
                  type: 'text',
                  placeholder: 'Unique link for user to go to their survey',
                  value: surveylink,
                  onChange: this.handleChange.bind(this, 'surveylink') }),
                _react2.default.createElement(ReactBootstrap.FormControl.Feedback, null)
              ),
              _react2.default.createElement(
                ReactBootstrap.FormGroup,
                null,
                _react2.default.createElement(
                  ReactBootstrap.ControlLabel,
                  null,
                  'Generated password:'
                ),
                _react2.default.createElement(ReactBootstrap.FormControl, {
                  type: 'text',
                  value: this.state.password, onChange: this.handleChange.bind(this, 'password') })
              ),
              _react2.default.createElement('div', { className: styles.spacer40 }),
              _react2.default.createElement(
                'div',
                { className: styles.textCenter },
                _react2.default.createElement(
                  ReactBootstrap.Button,
                  { className: 'btn btn-primary', onClick: this.handleSubmit },
                  _react2.default.createElement('i', { className: 'fa fa-circle-o' }),
                  ' ',
                  'Create user'
                )
              )
            )
          )
        ),
        _react2.default.createElement('div', { className: styles.spacer40 }),
        _react2.default.createElement(
          ReactBootstrap.Modal,
          { show: this.state.showModal, onHide: this.close },
          _react2.default.createElement(
            ReactBootstrap.Modal.Header,
            { closeButton: true },
            _react2.default.createElement(
              ReactBootstrap.Modal.Title,
              { className: styles.darkOrangeText },
              'User Created'
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Modal.Body,
            null,
            _react2.default.createElement(
              'p',
              null,
              'Send the ',
              _react2.default.createElement(
                'b',
                null,
                this.state.firstname
              ),
              ' their ',
              _react2.default.createElement(
                'b',
                null,
                'login details'
              ),
              ':'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Username:'
              ),
              ' ',
              this.state.username
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'password:'
              ),
              ' ',
              this.state.password
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Modal.Footer,
            null,
            _react2.default.createElement(
              ReactBootstrap.Button,
              { className: 'btn-success', onClick: this.close },
              'Continue'
            )
          )
        )
      );
    }
  }]);
  return AdminUsers;
}(_react.Component)) || _class);

/* eslint-enable */

exports.default = AdminUsers;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Admin/AdminCreateUser.js
// module id = 1143
// module chunks = 0